import { render, staticRenderFns } from "./BigPictureWrapper.vue?vue&type=template&id=d16310a8&scoped=true"
import script from "./BigPictureWrapper.vue?vue&type=script&lang=ts"
export * from "./BigPictureWrapper.vue?vue&type=script&lang=ts"
import style0 from "./BigPictureWrapper.vue?vue&type=style&index=0&id=d16310a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16310a8",
  null
  
)

export default component.exports